import React, { useState } from "react";
import './NaveBar.css';
import logo from './images/logo-logomark.png';
import profile from './images/user-profile.jpg';
import { useAuth } from '../../../context/AuthContext'; 
import { useNavigate } from 'react-router-dom';

function NaveBar() {
   const { logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();                     
    navigate('/');               
  };

  return (
    <div className="navebar">
      <div className="logo-nav">
        <img src={logo} alt="logo" />
      </div>

      <div className={`list-nav ${menuOpen ? 'open' : ''}`}>
        <a href="#">Home</a>
        <a href="#">About</a>
        <a href="#">Contact</a>
      </div>

      <div className="profile-nav">
        <img src={profile} alt="profile" />
      </div>

      <div className="button-nav">
        <button><a href="/">LOGOUT</a></button>
      </div>

      {/* Hamburger icon */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>
    </div>
  );
}

export default NaveBar;
